module.exports = __webpack_public_path__ + "vue/img/new_facility_4.48802b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intro/new_facility_4.png
// module id = EkRc
// module chunks = 1